import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
} from '@angular/common/http';
import { HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceDetectionService } from '../shared/services/device-detection.service';
import { environment } from 'src/environments/environment';
import { Platform } from '@ionic/angular';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LoginService } from '../shared/services/login-service';
// export class AuthInterceptor implements HttpInterceptor {
//   platform: string;
//   isNativeD: boolean;

//  constructor(
//     @Inject(PLATFORM_ID) private platformId: any,

//     private device: DeviceDetectionService
//   ) {
//     environment.platform;
//     let isNative = device.isNative()
//     this.isNativeD=isNative;
//     if (isNative) {
//       this.platform = device.isPlatform();
//     } else {
//       this.platform = environment.platform;
//     }    

//   }

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     const userProfileData = JSON.parse(localStorage.getItem('UserProfileData') || '{}');
//     const token = userProfileData?.accessToken;
//     const isFormData = req.body instanceof FormData;

//     let headers = req.headers;

//     if (token) {
//       headers = headers.set('Authorization', `Bearer ${token}`);
//     }

//     headers = headers.set('Accept', 'application/json');
//     headers = headers.set('platform', this.platform); 
//     headers = headers.set('timezone', environment.timezone); 


//     if (!isFormData) {
//       headers = headers.set('Content-Type', 'application/json');
//     }

//     const clonedRequest = req.clone({ headers });

//     return next.handle(clonedRequest);
//   }
// }
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
   const authService = inject(LoginService);
  const userProfileData = JSON.parse(localStorage.getItem('UserProfileData') || '{}');
    const token = userProfileData?.accessToken;
    

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        timezone: environment.timezone,
        platform: environment.platform || '3'
      },
    });
    return next(cloned).pipe(
    catchError((err) => {
      if (err.status === 401) {
        // 🔥 Clear session
        localStorage.removeItem('UserProfileData');
        authService.logout();
          //  localStorage.clear();
        // 🔥 Redirect to login
        router.navigate(['/login']);

        // Optionally show toast if you want
        // this.toastService.show('Session expired, please login again', 'danger');
      }

      return throwError(() => err);
    })
  );
  }

  return next(req);
};
